module.exports = __webpack_public_path__ + "static/media/Windmolen.151383c7.mp3";